<app-toasts-container></app-toasts-container>
<div class="movie-full-background"></div>
